/* tslint:disable */
/* eslint-disable */

import * as runtime from '../runtime';
import { BaseAPI } from '../baseApi';

export type VoiceActivityDraft = {
  activityName: string;
  date?: string; // "YYYY-MM-DD" — om utelämnat används idag
  startTime: string; // "HH:mm"
  duration: number; // minuter
  segment: 'MORNING' | 'AFTERNOON' | 'EVENING' | 'NIGHT';
};

export type VoiceParseResponse = {
  clarificationNeeded: boolean;
  clarificationQuestion: string | null;
  activities: VoiceActivityDraft[];
};

export interface ParseVoiceActivitiesRequest {
  transcription: string;
  language: string;
  currentDateTime: string; // ISO 8601
}

export class VoiceActivityApi extends BaseAPI {
  parseVoiceActivities = async (
    requestParameters: ParseVoiceActivitiesRequest,
  ): Promise<VoiceParseResponse> => {
    const headerParameters: runtime.HTTPHeaders = {
      'Content-Type': 'application/json',
    };

    try {
      const response = await this.request({
        path: '/ai/voice/parse',
        method: 'POST',
        headers: headerParameters,
        body: JSON.stringify({
          transcription: requestParameters.transcription,
          language: requestParameters.language,
          currentDateTime: requestParameters.currentDateTime,
        }),
      });

      const parsed = response.data as VoiceParseResponse;
      return parsed;
    } catch (error) {
      console.error('Error parsing voice activities:', error);
      throw error;
    }
  };
}
